import { HistoricoSwapModel } from './historico-swap.model';
import { SocioModel } from './socio.model';

export type StatusHabilitacao =
  | 'NAO_INICIADO'
  | 'EM_PREENCHIMENTO'
  | 'SUBMETIDO'
  | 'AJUSTE_SOLICITADO'
  | 'APROVADO';

export const STATUS_LABELS: Record<StatusHabilitacao, string> = {
  NAO_INICIADO: 'Não Iniciado',
  EM_PREENCHIMENTO: 'Em Preenchimento',
  SUBMETIDO: 'Submetido / Aguardando SWAP',
  AJUSTE_SOLICITADO: 'Ajustes Solicitados',
  APROVADO: 'Aprovado / Liberado',
};

export const STATUS_COLORS: Record<StatusHabilitacao, string> = {
  NAO_INICIADO: '#9E9E9E',
  EM_PREENCHIMENTO: '#FF9800',
  SUBMETIDO: '#2196F3',
  AJUSTE_SOLICITADO: '#F44336',
  APROVADO: '#4CAF50',
};

export class HabilitacaoSwapModel {
  constructor(
    public readonly id: number | null,
    public status: StatusHabilitacao,
    public socios: SocioModel[],
    public historico: HistoricoSwapModel[],
    public dataLiberacao: string | null,
    public ultimaAtualizacao: string | null,
    public mensagemSwap: string | null,
  ) {}

  static fromJson(json: any): HabilitacaoSwapModel {
    const status = json.status || json.statusHabilitacao || 'NAO_INICIADO';
    return new HabilitacaoSwapModel(
      json.id ?? null,
      status as StatusHabilitacao,
      (json.socios || []).map((s: any) => SocioModel.fromJson(s)),
      (json.historico || []).map((h: any) => HistoricoSwapModel.fromJson(h)),
      json.dataLiberacao || null,
      json.ultimaAtualizacao || null,
      json.mensagemSwap || json.mensagem || null,
    );
  }

  get isReadOnly(): boolean {
    return this.status === 'APROVADO' || this.status === 'SUBMETIDO';
  }

  get isEditable(): boolean {
    return (
      this.status === 'NAO_INICIADO' ||
      this.status === 'EM_PREENCHIMENTO' ||
      this.status === 'AJUSTE_SOLICITADO'
    );
  }

  get statusLabel(): string {
    return STATUS_LABELS[this.status] || this.status;
  }

  get statusColor(): string {
    return STATUS_COLORS[this.status] || '#9E9E9E';
  }

  get dataLiberacaoFormatada(): string {
    if (!this.dataLiberacao) return '';
    try {
      const date = new Date(this.dataLiberacao);
      return date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch {
      return this.dataLiberacao;
    }
  }
}
